<div class="row w-100 pt-3 text-center row-title">
    @if (!blockStatus) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Blocage des numéros surtaxés</div>
    }
    @if (blockStatus) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Déblocage des numéros surtaxés</div>
    }
</div>
<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100">
        Je souhaite
        @if (!blockStatus) {
            <span>bloquer</span>
        }
        @if (blockStatus) {
            <span>autoriser</span>
        } les appels vers les numéros surtaxés sur ma ligne <strong>{{ line.phoneNumber }}</strong>
        <br/><br/>
    </div>
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>
